<template>
  <div class="common page-btns-father">
    <div class="page-btns-main">
      <div class="common-title">融资信息</div>
      <div class="page-main no-shadow spaceLeft" style="padding-bottom:6px;">
        <a-row>
          <a-col span="12" class="text-item-box">
            <span class="text-item">银行名称：</span
            ><span class="text-val">{{ pageData.tenantName }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">申请日期：</span
            ><span class="text-val">{{
              pageData.fncBgDt | dateFormat("YYYY-mm-dd")
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">申请编号：</span
            ><span class="text-val">{{ pageData.fncJrnlId }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">意向放款日期：</span
            ><span class="text-val">{{
              pageData.fncDt | dateFormat("YYYY-mm-dd")
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">资金用途：</span
            ><span class="text-val">{{ pageData.rmrk }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">到期日期：</span
            ><span class="text-val">{{
              pageData.goldList &&
                pageData.goldList[0] &&
                pageData.goldList[0].exDay | dateFormat("YYYY-mm-dd")
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">还款方式：</span
            ><span class="text-val">{{
              pageData.instmRepyTpCd | rpMdCdTrans
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">融资金额：</span
            ><span class="text-val">{{ pageData.thsFncAmt | splitK }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">利率(%)：</span
            ><span class="text-val">{{ pageData.yrRate }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">预估利息：</span
            ><span class="text-val">{{ pageData.interest }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">融资手续费率(%)：</span
            ><span class="text-val">{{
              pageData.financingFeeRatio | splitK
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">预估融资手续费：</span
            ><span class="text-val">{{ pageData.fee | splitK }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">平台服务费：</span
            ><span class="text-val"
              >{{ pageData.platformInt | splitK }} 元</span
            >
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">合计金额：</span
            ><span class="text-val"
              ><span class="fin-num">{{ pageData.totalAmt | splitK }}</span>
              元</span
            >
          </a-col>
        </a-row>
      </div>
      <div class="common-title">祺信信息</div>
      <div>
        <a-table
          size="middle"
          :columns="goldColumns"
          :row-key="record => record.gldId"
          :data-source="pageData.goldList"
          bordered
          :pagination="false"
          :locale="{ emptyText: '暂无数据' }"
        >
          <template slot="gldAmt" slot-scope="text">{{
            text | splitK
          }}</template>
          <template slot="exDay" slot-scope="text">{{
            text | dateFormat("YYYY-mm-dd")
          }}</template>
          <template slot="canBeModified" slot-scope="text">{{
            text | gbCbmTrans
          }}</template>
          <template slot="oper" slot-scope="text, record">
            <a @click="toGoldDetail(record)" href="javascript:void(0);">详情</a>
          </template>
        </a-table>
      </div>

      <div class="common-title" style="margin-top:16px;">贸易资料</div>
      <div>
        <a-table
          size="middle"
          :columns="fileColumns"
          :row-key="record => record.fileId"
          :data-source="fileList"
          bordered
          :pagination="false"
          :locale="{ emptyText: '暂无数据' }"
        >
          <template slot="invoiceType" slot-scope="text">
            {{ text | invoiceTypeFilter }}
          </template>
          <template slot="invoiceNumber" slot-scope="text, record">
            <a @click="toInvoiceInfo(record)">{{ text }}</a>
          </template>
          <template slot="billTime" slot-scope="text">
            {{ text | dateFormat("YYYY-mm-dd") }}
          </template>
          <template slot="invoiceAmountWithVat" slot-scope="text">
            {{ text | splitK }}
          </template>
          <template slot="contractNo" slot-scope="text, record">
            <a v-if="text" @click="contractInfoOpen(record)">{{ text }}</a>
            <span v-else>--</span>
          </template>
          <template slot="otherFile" slot-scope="text, record">
            <a v-if="record.uploaded" @click="toDeliveryCreate(record)">查看</a>
            <span v-else>--</span>
          </template>
        </a-table>
      </div>

      <div v-show="relatedFileList.length > 0">
        <div class="common-title" style="margin-top:16px;">其他资料</div>
        <div class="page-main no-shadow">
          <a-row>
            <a-col
              span="12"
              class="text-item-box"
              v-for="(file, index) in relatedFileList"
              :key="index"
            >
              <span class="text-item"> {{ file.atchNm }}： </span>
              <span class="text-color-blue" @click="downFile(file)">
                {{ file.fileNm }}
              </span>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="common-title" style="margin-top:16px;">收款账户</div>
      <div class="page-main no-shadow">
        <a-row>
          <a-col span="12" class="text-item-box">
            <span class="text-item">账户名称：</span
            ><span class="text-val">{{ pageData.accountName }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">开户银行：</span
            ><span class="text-val">{{ pageData.withdrawAccountBank }}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col span="12" class="text-item-box">
            <span class="text-item">账户账号：</span
            ><span class="text-val">{{ pageData.withdrawAccountId }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">大额行号：</span
            ><span class="text-val">{{ pageData.largeBankNo }}</span>
          </a-col>
        </a-row>
      </div>

      <div class="common-title">相关协议</div>
      <div
        class="page-main no-shadow"
        style="margin-bottom:8px;"
        v-if="
          agreementList[0] &&
            !agreementList[0].artcCntnt &&
            agreementList[0].file
        "
      >
        <a-row>
          <a-col span="12" v-for="item in agreementList" :key="item.id">
            <div class="file-title">
              {{ item.artcTtl }}
            </div>
            <div class="text-color-blue" @click="downFile(item.file)">
              {{ item.file.fileNm }}
            </div>
          </a-col>
        </a-row>
      </div>

      <!-- 线上签署的相关协议 -->
      <div
        class="page-main no-shadow"
        style="margin-bottom:8px;"
        v-show="agreementList.length > 0"
        v-else
      >
        <div
          class="spaceLeft file-item"
          v-for="(file, index) in agreementList"
          :key="index"
        >
          <div class="file-title">
            <a @click="showfileOnline(file)">《{{ file.artcTtl }}》</a>
          </div>
        </div>
      </div>
    </div>
    <div class="spaceCenter page-bottom-btns">
      <a-button class="btn-blue-line" style="margin:30px 0;" @click="goBack()"
        >返回</a-button
      >
    </div>
    <!-- 查看弹窗 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 查看合同 -->
    <contractDialog
      title="匹配合同详情"
      ref="contractInfo"
      :readonly="true"
      :info.sync="curRow"
    />
    <!-- 相关附件 -->
    <relatedFileDialog ref="relatedFileDialog" />
    <!-- 查看线上的相关协议 -->
    <serviceView ref="serviceView" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getPrincipal, fncInfo } from "@/api/loan.js";
import { queryTradeBGByFncJrnlId } from "@/api/fncDetails.js";
import { queryAgreementList } from "@/api/sell.js";
import { fileQueryAPI } from "@/api/file.js";
import invoiceInfo from "@/pages/bill-manage/receivable/invoice-info-dialog";
import contractDialog from "@/pages/bill-manage/receivable/contract-info-dialog";
import relatedFileDialog from "@/pages/bill-manage/receivable/related-file-dialog";
import serviceView from "@/components/sign/serviceView";
export default {
  components: {
    invoiceInfo,
    contractDialog,
    relatedFileDialog,
    serviceView
  },
  name: "financingDetailPage",
  data() {
    return {
      pageData: {
        goldList: []
      },
      goldColumns: [
        {
          title: "祺信编号",
          dataIndex: "gldId"
        },
        {
          title: "开立方",
          dataIndex: "estbNm"
        },
        {
          title: "祺信金额(元)",
          dataIndex: "gldAmt",
          scopedSlots: { customRender: "gldAmt" }
        },
        {
          title: "到期日期",
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" }
        },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          scopedSlots: { customRender: "canBeModified" }
        },
        {
          title: "上级祺信",
          dataIndex: "oriGldId"
        },
        {
          title: "上级祺信流转方",
          dataIndex: "oriGldNm"
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" }
        }
      ],
      fileColumns: [
        {
          title: "买方名称",
          dataIndex: "buryName",
          width: 140,
          ellipsis: true
        },
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" },
          width: 90
        },
        {
          title: "发票号码",
          dataIndex: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
          width: 120
        },
        {
          title: "开票日期",
          dataIndex: "billTime",
          scopedSlots: { customRender: "billTime" },
          width: 120
        },
        {
          title: "含税金额(元)",
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          width: 120
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          scopedSlots: { customRender: "contractNo" },
          width: 100
        },
        {
          title: "相关附件",
          dataIndex: "otherFile",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "otherFile" }
        }
      ],

      fileList: [],
      agreementList: [],
      loading: false,
      curRow: null,
      relatedFileList: [], //其他资料
      fileListOnline: [] //相关协议线上签署的
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    }),
    fncJrnlId() {
      return this.$route.params.id;
    },
    estbNm() {
      if (this.pageData.goldList && this.pageData.goldList[0]) {
        return this.pageData.goldList[0].estbNm;
      } else {
        return "";
      }
    }
  },
  created() {
    this.getFncInfo();
    this.getPrincipal();
    this.fileQuery();
    this.queryAgreementList();
    this.queryRelatedFile();
  },
  mounted() {},
  methods: {
    getFncInfo() {
      const param = {
        fncJrnlId: this.fncJrnlId
      };
      fncInfo(param)
        .then(res => {
          this.pageData = res.data;
          this.pageData.goldList = this.pageData.goldList || [];
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPrincipal() {
      const param = {
        fncJrnlId: this.fncJrnlId
      };
      getPrincipal(param)
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
    },
    // 查询贸易背景
    fileQuery() {
      this.loading = true;
      queryTradeBGByFncJrnlId({
        useCase: "financing",
        fncJrnlId: this.fncJrnlId,
        gldId: this.$route.query.gldId
      })
        .then(res => {
          this.pushTableDataInv(res.data || []);
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    // 追加贸易背景列表
    pushTableDataInv(list = [], disabled) {
      list.forEach(item => {
        if (item.invoices) {
          item.invoices.forEach(inv_item => {
            this.fileList.push({
              disabled: disabled,
              useCase: "financing",
              ...item.contract,
              ...inv_item,
              fncJrnlId: this.fncJrnlId,
              invoice: inv_item,
              contract: {
                file: item.file,
                ...item.contract
              },
              id: inv_item.id
            });
          });
        }
      });
    },
    // 查询法律文本
    queryAgreementList() {
      queryAgreementList({ fncJrnlId: this.fncJrnlId }).then(res => {
        this.agreementList = res.data.list;
      });
    },
    toGoldDetail(data) {
      this.MENUAPI.goToOneTab({
        path: "circulation/borrow/gold",
        query: {
          gldId: data.gldId,
          noMenu: true, //跳转页面需要，是否为菜单页面
          fromPath: "circulation/borrow/details/" + this.fncJrnlId //跳转页面需要，来源路径，用于页面返回
        },
        noMenu: true
      });
    },
    contract(item) {
      this.$router.push({
        name: "contractDetail",
        params: this.utils.deepClone(this.pageData)
      });
    },
    fileDetail(item) {
      location.href =
        "/gb-bigtree-file/download/fileDownload/install/" +
        item.fileRte +
        "/" +
        item.fileNm;
    },
    downFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    },
    // 查看发票
    toInvoiceInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    contractInfoOpen(data) {
      this.curRow = data;
      this.$refs.contractInfo.open({ fncJrnlId: this.pageData.fncJrnlId });
    },
    // 相关附件上传、编辑、查看
    toDeliveryCreate(record) {
      this.$refs.relatedFileDialog.open({
        invData: record,
        dialogType: "detail"
      });
    },
    // 根据融资编号插叙其他资料
    queryRelatedFile() {
      fileQueryAPI({
        mdlId: "fnc",
        tblBlId: this.fncJrnlId
      }).then(res => {
        this.relatedFileList = res.data;
      });
    },
    // 查看线上的相关协议
    showfileOnline(file) {
      this.$refs.serviceView.open({
        title: file.artcTtl,
        artcCntnt: file.artcCntnt
      });
    },
    goBack() {
      this.MENUAPI.goToOneTab({
        path: this.$route.query.fromPath || "circulation/borrow",
        noMenu: this.$route.query.noMenu
      });
    }
  },
  activated() {}
};
</script>
<style scoped lang="less">
.text-item-box {
  margin-bottom: 12px;
  .text-item {
    color: #737f8e;
    display: inline-block;
    min-width: 120px;
    text-align: right;
  }
  .fin-num {
    color: #1990ff;
    font-weight: bold;
    font-size: 18px;
  }
  .text-val {
    color: #333333;
  }
}
.file-title {
  color: #333333;
  font-weight: bold;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/financing-page/financing-detail-page.vue